import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MemoryInput = ({ onMemorySubmit }) => {
  const navigate = useNavigate();
  const [memoryData, setMemoryData] = useState({
    title: '',
    date: '',
    location: '',
    details: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMemoryData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (memoryData.details.trim()) {
      const newMemory = {
        ...memoryData,
        id: Date.now()
      };
      onMemorySubmit(newMemory);
      navigate(`/memory/${newMemory.id}`);
    }
  };

  return (
    <div className="memory-input-container">
      <h2>Memory Journal</h2>
      <p className="memory-input-guide">
        Take your time to write down your precious memory. 
        Every detail helps create a more vivid memory palace.
      </p>
      <form onSubmit={handleSubmit} className="memory-form">
        <div className="memory-form-field">
          <label htmlFor="title">Memory Title</label>
          <input
            type="text"
            id="title"
            name="title"
            value={memoryData.title}
            onChange={handleChange}
            placeholder="Give your memory a name (e.g., 'Grandmother's Cookie Day')"
            className="memory-input"
          />
        </div>

        <div className="memory-form-row">
          <div className="memory-form-field">
            <label htmlFor="date">When did this happen?</label>
            <input
              type="text"
              id="date"
              name="date"
              value={memoryData.date}
              onChange={handleChange}
              placeholder="Approximate date or time period"
              className="memory-input"
            />
          </div>

          <div className="memory-form-field">
            <label htmlFor="location">Where did this happen?</label>
            <input
              type="text"
              id="location"
              name="location"
              value={memoryData.location}
              onChange={handleChange}
              placeholder="Place or location"
              className="memory-input"
            />
          </div>
        </div>

        <div className="memory-form-field">
          <label htmlFor="details">Memory Details</label>
          <textarea
            id="details"
            name="details"
            value={memoryData.details}
            onChange={handleChange}
            placeholder="Share all the details you remember... What did you see? Smell? Hear? How did you feel?"
            className="memory-textarea"
            rows={6}
          />
        </div>

        <button type="submit" className="memory-submit-btn">
          Create Memory Palace
        </button>
      </form>
    </div>
  );
};

export default MemoryInput; 